import { DATE_FORMAT_REGEX } from "./constants";

// Extract timestamp from filename and format as YYYY-MM-DD HH:MM:SS
export const formatFileDate = fileName => {
  if (!fileName || typeof fileName !== "string") return null;

  // Extract timestamp from filename (format: serialNumber_timestamp.tar.gz)
  const match = fileName.match(/_(\d+)\.tar\.gz$/);
  if (!match) return null;

  const timestampSeconds = parseInt(match[1], 10);
  if (isNaN(timestampSeconds)) return null;

  // Convert epoch seconds (UTC) to local timezone Date object
  const date = new Date(timestampSeconds * 1000);

  // Format as YYYY-MM-DD HH:MM:SS
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// Validate date format (YYYY-MM-DD)
export const validateDateFormat = dateString => {
  if (!dateString) return false;
  if (!DATE_FORMAT_REGEX.test(dateString)) return false;

  // Check if it's a valid date
  const date = new Date(dateString);
  const [year, month, day] = dateString.split("-").map(Number);
  return date.getFullYear() === year && date.getMonth() + 1 === month && date.getDate() === day;
};

export const extractTimestamp = filename => {
  if (typeof filename !== "string") return 0;
  const match = filename.match(/_(\d+)\.tar\.gz$/);
  return match ? Number(match[1]) : 0;
};

export const newLogoIconVisibility = fileName => {
  const currentTime = Math.floor(new Date().getTime() / 1000);
  const fileLogTime = extractTimestamp(fileName);
  if (currentTime - fileLogTime <= 300) {
    return true;
  }
  return false;
};
